import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import aboutus from '../views/aboutus.vue'
import contactus from '../views/contactus.vue'
import useragreement from '../views/useragreement.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta:{
      title:'官网主页'
    }
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: aboutus,
    meta:{
      title:'关于我们'
    }
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: contactus,
    meta:{
      title:'联系我们'
    }
  },
  {
    path: '/useragreement',
    name: 'useragreement',
    component: useragreement,
    meta:{
      title:'用户协议'
    }
  },
 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
